import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import ProfileSettings from "./ProfileSettings";
import SecuritySettings from "./SecuritySettings";
import UpdatePassword from "./UpdatePassword";
import Billing from "./Billing";
import Organization from "./Organization";
import SideNav from "./sidenav";
import "./index.css";

function Settings() {  
  return (
    <div className="settings-container">
      <SideNav window_path={window.location.pathname} />
      <div className="main-content">
        <Switch>
          <Route path="/settings/profile" component={ProfileSettings} />
          <Route path="/settings/security" component={SecuritySettings} />
          <Route path="/settings/password" component={UpdatePassword} />
          <Route path="/settings/billing" component={Billing} />
          <Route path="/settings/organizations" component={Organization} />
          <Redirect from="/settings" to="/settings/profile" />
        </Switch>
      </div>
    </div>
  );
}

export default Settings;
